import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { CellFunction, DirectCell, YesNoCell } from '../../cells';

import { IEpxMedComp } from '../../../../../libs/apps/epxmedcomp';

const EpxMedCompTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxMedComp>[] = [
    {
      Header: 'Took Medication',
      accessor: 'tookMedication',
      Cell: ResponseGuard(
        YesNoCell('tookMedication') as CellFunction<IEpxMedComp>
      )
    },
    {
      Header: 'Missed Reason',
      accessor: 'missedReason',
      Cell: ResponseGuard(
        DirectCell('missedReason') as CellFunction<IEpxMedComp>
      )
    }
  ];
  return (
    <SessionTable<IEpxMedComp>
      url="/epxmedcomp/data/"
      columns={columns}
      disableTypeColumn
      {...props}
    />
  );
};

export default EpxMedCompTable;
